/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

//some misc firebase related utilities

import { IFirebaseRefLike } from './IRefLike';

/**
 * a "safe" way of mapping data into an object from a firebase update
 * @param  targetObject [description]
 * @param  key          [description]
 * @param  shouldAdd    [description]
 * @param  data         [description]
 * @return              [description]
 */

export function addOrRemoveFirebaseProperty(
	targetObject: { [x: string]: unknown },
	key: string | number,
	shouldAdd: unknown,
	data: unknown
): void {
	if (shouldAdd) {
		targetObject[key] = data;
	} else {
		delete targetObject[key];
	}
}

export function isRef(x: unknown): x is IFirebaseRefLike {
	//a _facinating_ choice for the type check. Technically this belongs to "Query" in
	//modular, but ref inherits from query
	return !!x && (x as IFirebaseRefLike).ref !== undefined;
}
